import styled from 'styled-components';
import { CountdownTimer } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import { Trans } from '@lingui/react/macro';

export function TimerTooltipTitle() {
  return (
    <Title>
      <Trans>
        <Icon component={CountdownTimer} size={16} />
        Timer scheduled to start later.
        <br />
        Currently, only you can see this timer.
      </Trans>
    </Title>
  );
}

const Title = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  text-align: left;
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
`;
